import { derived, writable } from 'svelte/store'

import fetchStore from '../lib/fetchStore'

import { thirdPartyTable } from '../urlMenu'

export default function () {
  // build our object of data calls for the home page (we imported the ones we need from the 'menu' above)
  const dataCalls = {
    thirdPartyTable,
  }

  // This line doesn't look like much, but this function call is what returns the mains Svelte stores after fetching the data.
  const [data, loading, error] = fetchStore(dataCalls)

  // `data` is now a Svelte store. We can build upon the main data store we just created by using `derived()`
  // to create transformations our components can import and use directly.
  // this should be the last place we touch the data before it's dropped into the component.

  const thirdPartyTableStore = derived(data, ($data)=> {
    if($data.thirdPartyTable) {
      return $data.thirdPartyTable
    } else {
      return []
    }
  }, [])
  // @TODO attach the data or derive, whichever
  
  return [
    data, 
    loading, 
    error,
    thirdPartyTableStore,
  ]
}